import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { FormEventsComponent } from "./form-events.component";
import { GridModule } from "@features/grid";
import { FilterModule } from "@features/filter";

@NgModule({
    declarations: [FormEventsComponent],
    imports: [  
          FormsModule, GridModule, FilterModule, PrimeNgModule, MiproSharedModule, FormsModule, PrimeNgModule,ReactiveFormsModule 

    ],
    exports: [FormEventsComponent]
})
export class FormEventsModule {}
